import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from 'vue';

  
  import { defineComponent } from 'vue';

  const __default__ = defineComponent({
    name: 'AudioView',
  });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    src: { type: String, required: true },
    type: { type: String, required: true }
  },
  setup(__props: any) {

const props = __props as { src: string, type: string };

  
  const { src, type } = toRefs(props);

return { __sfc: true,props, src, type }
}

})